import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IoChevronDown } from 'react-icons/io5';

export const navItems = [
  { label: 'Home', to: '/home' },
  {
    label: 'Exhibition',
    children: [
      { label: 'Exhibitor Profile' },
      { label: 'Space Booking Form' },
      { label: 'Floor Plan' },
      { label: 'List of Participants' },
    ],
  },
  {
    label: 'Visitor',
    children: [
      { label: 'Visitor Profile' },
      { label: 'Visitor Registration' },
    ],
  },
  { label: 'Gallery' },
  { label: 'Contact', to: '/contact' },
];

function NavItemContent({ item }) {
  if (item.to) {
    return (
      <NavLink
        to={item.to}
        className={({ isActive }) =>
          `ma-nav-link${isActive ? ' ma-nav-link--active' : ''}`
        }
        end={item.to === '/home'}
      >
        {item.label}
      </NavLink>
    );
  }

  return <span className="ma-nav-link ma-nav-link--static">{item.label}</span>;
}

function MainNav() {
  return (
    <nav className="ma-main-nav" aria-label="Main navigation">
      <ul className="ma-nav-list">
        {navItems.map((item) =>
          item.children ? (
            <li key={item.label} className="ma-nav-item ma-nav-item--dropdown">
              <button type="button" className="ma-nav-link ma-nav-link--dropdown" aria-haspopup="true">
                {item.label}
                <IoChevronDown className="ma-nav-chevron" aria-hidden="true" />
              </button>
              <ul className="ma-dropdown-menu">
                {item.children.map((child) => (
                  <li key={child.label}>
                    {child.to ? (
                      <Link to={child.to} className="ma-dropdown-link">
                        {child.label}
                      </Link>
                    ) : (
                      <span className="ma-dropdown-link ma-dropdown-link--static">
                        {child.label}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          ) : (
            <li key={item.label} className="ma-nav-item">
              <NavItemContent item={item} />
            </li>
          )
        )}
      </ul>
    </nav>
  );
}

export default MainNav;
